module.exports = __webpack_public_path__ + "static/media/CTLI_16-315w.a2cda56e.jpg";